import {
  ComponentPropsWithoutRef,
  ElementType,
  ForwardedRef,
  ReactNode,
  Ref,
} from 'react';
import { Atoms, atoms, extractAtoms } from '../atom';

type AsProps<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  as?: T;
};

export type ElementProps<T extends ElementType = ElementType> = AsProps<T> &
  Atoms & {
    children?: ReactNode;
    ref?: Ref<HTMLElement>;
  };

export const Element = <T extends ElementType = 'div'>(
  props: ElementProps<T>
) => {
  const {
    as: Component = 'div',
    className,
    children,
    typography,
    ref: forwardedRef,
    ...rest
  } = props;
  const { atomProps, componentProps } = extractAtoms(
    rest as Omit<ElementProps<T>, 'children'>
  );
  const atomClassName = atoms({ className, typography, ...atomProps });

  return (
    <Component
      {...componentProps}
      className={atomClassName}
      ref={forwardedRef as ForwardedRef<HTMLDivElement>}>
      {children}
    </Component>
  );
};
